import { ListTree } from "lucide-react";
import { OutlineItem } from "../types";

interface OutlinePanelProps {
  items: OutlineItem[];
  onSelect: (item: OutlineItem) => void;
}

export const OutlinePanel = ({ items, onSelect }: OutlinePanelProps) => (
  <aside className="panel outline-panel" aria-label="Document outline">
    <div className="panel-title">
      <ListTree size={18} />
      <span>Outline</span>
    </div>
    {items.length === 0 ? (
      <p className="muted">Headings appear here as you write.</p>
    ) : (
      <nav className="outline-list">
        {items.map((item) => (
          <button
            key={`${item.line}-${item.text}`}
            type="button"
            className="outline-item"
            style={{ ["--outline-depth" as string]: item.level - 1 }}
            title={item.text}
            onClick={() => onSelect(item)}
          >
            {item.text}
          </button>
        ))}
      </nav>
    )}
  </aside>
);
